/**
 * Footer Section
 * ==============
 * Site footer with links and copyright
 */

import React from 'react';
import { config } from '../../data/config';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-section" id="footer">
      <div className="footer-container">
        {/* Top Section */}
        <div className="footer-top">
          {/* Brand */}
          <div className="footer-brand">
            <div className="footer-logo">
              <img src="/assets/dravonix_logo.png" alt="Dravonix" />
            </div>
            <p className="footer-tagline">Engineering the Decentralized Future</p>
          </div>

          {/* Links */}
          <div className="footer-links">
            {/* Services */}
            <div className="footer-col">
              <h4>Services</h4>
              <ul>
                {config.footer.services.map((link) => (
                  <li key={link.name}>
                    <a href={link.href}>{link.name}</a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Company */}
            <div className="footer-col">
              <h4>Company</h4>
              <ul>
                {config.footer.company.map((link) => (
                  <li key={link.name}>
                    <a href={link.href}>{link.name}</a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact */}
            <div className="footer-col">
              <h4>Contact</h4>
              <ul>
                <li>
                  <a href="mailto:support@dravonixglobal.com">
                    <i className="fas fa-envelope" />
                    support@dravonixglobal.com
                  </a>
                </li>
                <li>
                  <a href={config.social.whatsapp} target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-whatsapp" />
                    WhatsApp
                  </a>
                </li>
                <li>
                  <a href={config.social.telegram} target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-telegram-plane" />
                    Telegram
                  </a>
                </li>
                <li className="footer-address">
                  <i className="fas fa-map-marker-alt" />
                  <span>3rd Floor, AD 45, Shanthi Colony, Anna Nagar, Chennai, Tamil Nadu 600040</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="footer-divider" />

        {/* Bottom Section */}
        <div className="footer-bottom">
          {/* Copyright */}
          <div className="footer-copyright">
            <p>© {currentYear} Dravonix. All rights reserved.</p>
          </div>

          {/* Social Icons */}
          <div className="footer-social">
            <a href={config.social.whatsapp} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
              <i className="fab fa-whatsapp" />
            </a>
            <a href={config.social.telegram} target="_blank" rel="noopener noreferrer" aria-label="Telegram">
              <i className="fab fa-telegram-plane" />
            </a>
            <a href={config.social.twitter} target="_blank" rel="noopener noreferrer" aria-label="Twitter">
              <i className="fab fa-twitter" />
            </a>
            <a href={config.social.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <i className="fab fa-linkedin-in" />
            </a>
            <a href={config.social.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <i className="fab fa-instagram" />
            </a>
            <a href={config.social.youtube} target="_blank" rel="noopener noreferrer" aria-label="YouTube">
              <i className="fab fa-youtube" />
            </a>
          </div>

          {/* Legal */}
          <div className="footer-legal">
            {config.footer.legal.map((link, index) => (
              <React.Fragment key={link.name}>
                <a href={link.href}>{link.name}</a>
                {index < config.footer.legal.length - 1 && <span>•</span>}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>

      {/* Background Decoration */}
      <div className="footer-bg">
        <div className="footer-gradient" />
      </div>
    </footer>
  );
};

export default Footer;
